import { render, staticRenderFns } from "./transfer-panel.vue?vue&type=template&id=29b5a24a&"
import script from "./transfer-panel.vue?vue&type=script&lang=js&"
export * from "./transfer-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports